export const GET_PIPE_OPENINGS = 'GET_PIPE_OPENINGS';
export const GET_PIPE_OPENINGS_PAGE = 'GET_PIPE_OPENINGS_PAGE';
export const PIPE_OPENING_REQUEST = 'PIPE_OPENING_REQUEST';
export const CREATE_PIPE_OPENING = 'CREATE_PIPE_OPENING';
export const UPDATE_PIPE_OPENING = 'UPDATE_PIPE_OPENING';
export const DELETE_PIPE_OPENING = 'DELETE_PIPE_OPENING';
export const PIPE_OPENING_REQUEST_FAILURE = 'PIPE_OPENING_REQUEST_FAILURE';
export const GET_PIPE_OPENINGS_WITH_DETAIL = 'GET_PIPE_OPENINGS_WITH_DETAIL';
export const PIPE_OPENING_REQUEST_SUCCESS  = 'PIPE_OPENING_REQUEST_SUCCESS';